import * as angular from "angular";
import {IController} from "angular";

export class serviceRiskTypesMultiSelectController implements IController {

    selectedRiskTypes: any;
    noUnderline: any;
    ngPlaceholder: any;
    onChange: Function;

    riskTypes: any[];
    searchTerm: string;

    /* @ngInject */
    constructor(private deliveriesConstants, private $mdSelect) {}

    $onInit() {
       this.riskTypes = this.deliveriesConstants.riskTypes;
       this.searchTerm = '';
    }

    public cancel() {
        this.$mdSelect.hide();
    }

    public select() {
        this.searchTerm = '';
        this.$mdSelect.hide();
    }

    public reset() {
        this.searchTerm = '';
        this.onChange({riskTypes: []});
        this.$mdSelect.hide();
    }


}

angular
    .module('bringoz.admin.deliveries')
    .component('serviceRiskTypesMultiSelect', {
        bindings: {
            selectedRiskTypes: '<',
            noUnderline: '@?',
            ngPlaceholder: '@?',
            onChange: '&'
        },
        template: require('./service-risk-types-multi-select.html').default,
        controller: serviceRiskTypesMultiSelectController
    });